import { __assign, __generator, __spreadArray } from "tslib";
import { call } from 'redux-saga/effects';
import { request } from '../../xhr';
var fakeCollections = [];
function getFakeCollections() {
    if (process.env.NODE_ENV !== 'production') {
        var collections = 
        // eslint-disable-next-line global-require
        require('@wix/da-sample-data').collections;
        // move Featured folder to first
        var featured = null;
        var nonFeatured = [];
        for (var _i = 0, collections_1 = collections; _i < collections_1.length; _i++) {
            var collection = collections_1[_i];
            if (collection.name === 'Featured') {
                featured = collection;
            }
            else {
                nonFeatured.push(collection);
            }
        }
        // duplicate non-featured so we can get some pagination
        // but randomize ids so the collections aren't deduped in the Stream
        var additionalCollections = __spreadArray(__spreadArray(__spreadArray([], nonFeatured, true), nonFeatured, true), nonFeatured, true).map(function (c) { return (__assign(__assign({}, c), { folderId: Math.floor(Math.random() * 1000) })); });
        fakeCollections = __spreadArray(__spreadArray(__spreadArray([], (featured ? [featured] : []), true), nonFeatured, true), additionalCollections, true);
    }
    return fakeCollections;
}
export function doFetchCollections(offset, limit) {
    var params, result;
    if (offset === void 0) { offset = 0; }
    if (limit === void 0) { limit = 20; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    type: 'collection',
                    offset: offset,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'gallection/folders',
                        params: params,
                    }, function () {
                        var collections = getFakeCollections();
                        var nextOffset = offset + limit;
                        var hasMore = collections.length - 1 > nextOffset;
                        return {
                            hasMore: hasMore,
                            nextOffset: hasMore ? nextOffset : null,
                            results: collections.slice(offset, nextOffset),
                        };
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doFetchContainingCollectionIds(deviationId) {
    var params, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    deviationid: deviationId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'collections/collections_for_deviation',
                        params: params,
                    }, function () {
                        var res = {
                            collectionIds: [],
                        };
                        return res;
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result && result.collectionIds];
        }
    });
}
export function doCommitCollections(folderIds, deviationId) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    itemid: deviationId,
                    folderids: folderIds,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'collections/collect',
                        data: data,
                    }, function () { return ({
                        success: true,
                    }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function doCreateCollection(name) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    name: name,
                    type: 'collection',
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/create',
                        data: data,
                    }, function (_a) {
                        var fakeName = _a.data.name;
                        return ({
                            success: true,
                            gallection: __assign(__assign({}, getFakeCollections()[0]), { folderId: Math.round(Math.random() * 100000), name: fakeName }),
                        });
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result || { success: false }];
        }
    });
}
export function doFave(deviationId) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    itemid: deviationId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'fave',
                        data: data,
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result || { success: false }];
        }
    });
}
export function doUnfave(deviationId) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    itemid: deviationId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'unfave',
                        data: data,
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result || { success: false }];
        }
    });
}
//# sourceMappingURL=xhr.js.map